import {Button, Tooltip} from '@mui/material'
import type {FC, ReactElement} from 'react'
import {NavLink, useNavigate} from 'react-router-dom'

interface ActionButtonProps {
  dataName?: string
  dataCy: string
  link?: string
  title: string
  icon: ReactElement
  onClick?: () => void
  target?: string
  isDisabled?: boolean
}

const ActionButton: FC<ActionButtonProps> = ({
  dataName,
  dataCy,
  link,
  title,
  icon,
  onClick,
  target,
  isDisabled = false,
}): ReactElement => {
  const navigate = useNavigate()

  const handleClick = (): void => {
    if (onClick) {
      onClick()
    } else if (link) {
      // Signals links used to be rewritten here — stripped to ?equipment= and
      // handed the id in router state — because the per-line signals page read
      // it from there. buildSignalExplorerUrl now emits the final URL, and the
      // rewrite would only drop the params it carries.
      navigate(link)
    }
  }

  return (
    <Tooltip title={title} arrow>
      <Button
        component={link && target === '_blank' ? NavLink : 'button'}
        to={link && target === '_blank' ? link : undefined}
        data-testid="mbai-main-action-button-component"
        data-name={dataName}
        data-cy={dataCy}
        variant="outlined"
        disabled={isDisabled}
        target={target}
        onClick={handleClick}
        sx={{
          width: '100%',
          minWidth: 0,
          px: 0.5,
          '&:hover': {color: 'primary.main'},
        }}
      >
        {icon}
      </Button>
    </Tooltip>
  )
}

export default ActionButton
